import { render, staticRenderFns } from "./TicketGreed.vue?vue&type=template&id=ac3c2ff0&scoped=true&"
import script from "./TicketGreed.vue?vue&type=script&lang=js&"
export * from "./TicketGreed.vue?vue&type=script&lang=js&"
import style0 from "./TicketGreed.vue?vue&type=style&index=0&id=ac3c2ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3c2ff0",
  null
  
)

export default component.exports